import React from 'react';

import {useGetStoreInfoValues} from 'desktop/hooks/useGetStoreInfoValues/useGetStoreInfoValues';

import {UpsellAccessoryType, UpsellType} from '../../types/upsellsTypes';
import {UpgradeItemConnected} from '../upgradeItem/upgradeItem';
import {UpsellItemWrapperConnected} from '../upsellItemWrapper/upsellItemWrapper';

export type PropsType = {
    upgrades: Array<UpsellType>;
    onView: (upsell: UpsellType) => void;
};

/**
 * Upsells List component
 * @param {PropsType} props - Component props
 * @returns {Node} - Rendered react component
 */
export const UpgradesList = ({onView, upgrades}: PropsType) => {
    const {actualPhoneNumber} = useGetStoreInfoValues();
    return (
        <ul>
            {upgrades.map(
                (upsell: UpsellType) =>
                    upsell.isActive && (
                        <UpsellItemWrapperConnected
                            key={upsell.sku}
                            onView={onView}
                            upsell={upsell as UpsellAccessoryType}
                        >
                            <UpgradeItemConnected phone={actualPhoneNumber} upsell={upsell} />
                        </UpsellItemWrapperConnected>
                    ),
            )}
        </ul>
    );
};
